<template>
  <select
    class="form-control"
    v-bind:class="{ 'is-invalid': erro }"
    v-bind:value="value"
    v-on:input="$emit('input', $event.target.value)"
    @change="onChange($event)"
  >
    <option v-if="itemSelecione" :disabled="!itemSelecione" value>Escolha um item</option>
    <option v-for="item in itens" :key="item.id" :item="item" :value="item.id">{{item.nome}}</option>
  </select>
</template>

<script>
export default {
  name: "Combo",
  components: {},
  props: {
    itens: Array,
    value: { type: String, default: "" },
    erro: { type: Boolean, default: false },
    itemSelecione: { type: Boolean, default: false },
  },
  methods: {
    onChange()
    {
      this.$emit("change");
    }
  },
};
</script>

<style>
</style>